var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'design-tag',
    'title-tag',
    _vm.form.editing === _vm.field.uuid ? 'editing' : ''
  ]},[_c('SvgIcon',{attrs:{"name":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }